// extracted by mini-css-extract-plugin
module.exports = {"price":"price_price__oxYSY"};